// extracted by mini-css-extract-plugin
export default {"controlsContainer":"CompaniesPage_controlsContainer__H1Z-1","listItemName":"CompaniesPage_listItemName__KQo5T","listItemContainer":"CompaniesPage_listItemContainer__YWkg7"};